<td class="d-md-flex align-items-center">
  <img [src]="cryptoAssetPath + crypto.isin + '.svg'" [alt]="crypto.description + '-logo'" class="p-2" />
  <web-components-instrument-details-link [isin]="crypto.isin" linkCssClass="text-color-primary align-text-top">
    <span class="description-text">{{ crypto.description }}</span>
  </web-components-instrument-details-link>
</td>
<td class="fixed-width">
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.quote' | transloco }}
    </div>
    <ng-container *ngIf="crypto.bid; else novalue">
      <ng-container *ngIf="crypto.bid < 50">
        <div zeroBlink [val]="crypto.bid">
          {{ crypto.bid | currency: 'EUR' : 'symbol' : '1.2-8' }}
        </div>
      </ng-container>

      <ng-container *ngIf="crypto.bid >= 50">
        <div zeroBlink [val]="crypto.bid">
          {{ crypto.bid | currency: 'EUR' : 'symbol' : '1.2-8' }}
        </div>
      </ng-container>
    </ng-container>
  </div>
</td>
<td class="fixed-width">
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.perf' | transloco }}
    </div>
    <ng-container *ngIf="crypto.percent >= 0 || crypto.percent < 0; else empty">
      <div [ngClass]="crypto.percent >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
        {{ crypto.percent >= 0 ? '+' : '' }}{{ crypto.percent | number: '1.2-2' }} %
      </div>
    </ng-container>
    <ng-template #empty>
      <div class="text-right">&mdash;</div>
    </ng-template>
  </div>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.perfAbsolut' | transloco }}
    </div>
    <ng-container *ngIf="crypto.abs >= 0 || crypto.abs < 0; else empty">
      <div [ngClass]="crypto.abs >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
        {{ crypto.abs >= 0 ? '+' : '' }}{{ crypto.abs | number: '1.2-8' }}
      </div>
    </ng-container>
    <ng-template #empty>
      <div class="text-right">&mdash;</div>
    </ng-template>
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.time' | transloco }}
    </div>
    <ng-container *ngIf="crypto.quoteTime; else novalue">
      <div class="text-color-primary">
        {{ crypto.quoteTime | date: 'HH:mm:ss' }}
      </div>
    </ng-container>
  </div>

  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'crypto.overview.date' | transloco }}
    </div>
    <ng-container *ngIf="crypto.quoteTime; else novalue">
      <div class="text-color-primary">
        {{ crypto.quoteTime | date: 'dd.MM.yy' }}
      </div>
    </ng-container>
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div
      class="trade savings-plan cursor-pointer"
      title="Sparplan anlegen"
      [routerLink]="commonRoutes.postlogin.add_savings_plan + '/' + crypto.isin"
    >
      <svg class="icon icon-24">
        <use xlink:href="/assets/img/svgs/svgset.svg#pig" />
      </svg>
    </div>
    <div
      class="trade buy cursor-pointer"
      title="Kaufen"
      [routerLink]="commonRoutes.postlogin.buyAndSell"
      [queryParams]="{
        isin: crypto.isin,
        direction: 'buy',
      }"
    >
      K
    </div>
    <div
      class="trade sell cursor-pointer"
      title="Verkaufen"
      [routerLink]="commonRoutes.postlogin.buyAndSell"
      [queryParams]="{
        isin: crypto.isin,
        direction: 'sell',
      }"
    >
      V
    </div>
  </div>
</td>

<ng-template #novalue>
  <div class="text-color-primary">&mdash;</div>
</ng-template>
